<template>
  <div class="order-cart">
    <div class="left-cart">
      <div class="free-title center">Basic</div>
      <div class="left-cart-body">
        <div class="left-cart-body-div">
          <span class="left-cart-text">Limited Theme</span>
          <span class="left-cart-text">Limited Backgrounds</span>
          <span class="left-cart-text">Basic Avatar Pro Features</span>
          <span class="left-cart-text">Basic Server Filter</span>
          <span class="left-cart-text">Live Game Details</span>
          <span class="left-cart-text">Rejoin Last Server</span>
          <span class="left-cart-text">Random Server</span>
          <span class="left-cart-text">Friends Quick Search</span>
        </div>
      </div>
    </div>
    <div style="width: 120px"></div>
    <div class="right-cart">
      <div class="expert-title center">
        <div><svg width="40px" height="40px" viewBox="0 0 17 13" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-252.000000, -108.000000)" fill="#FFE0B1" fill-rule="nonzero"><g transform="translate(260.500000, 114.500000) rotate(-360.000000) translate(-260.500000, -114.500000) translate(252.000000, 108.000000)"><path d="M0,3.78658768 L0.0545246208,3.64500766 C0.194730813,3.25969495 0.560824731,3.00162505 1.0067583,2.97295061 C1.41374569,2.94606832 1.8207331,3.1647109 2.0115693,3.5088041 C2.20630011,3.86006593 2.15177549,4.27405306 1.8694158,4.58230323 C1.83631157,4.61635412 1.80320732,4.65040501 1.76620846,4.68983236 C2.55486826,5.13428609 3.33963343,5.57336335 4.12050401,6.01602493 C4.41649484,6.18448723 4.71443299,6.35294954 5.01042382,6.51603537 C5.17983962,6.60743513 5.31030927,6.58055284 5.40183275,6.42821992 C6.2995418,4.92281213 7.19725084,3.4156122 8.10274912,1.89407505 C7.71134019,1.71127553 7.45819012,1.43169981 7.43482243,1.01771266 C7.41924397,0.727384016 7.53024053,0.478274878 7.75418097,0.275761685 C8.19816722,-0.122096084 8.92646047,-0.084460885 9.3159221,0.356408537 C9.76380296,0.861795429 9.60217638,1.45320565 8.89140892,1.89765936 C9.12313858,2.28834853 9.35681555,2.68082984 9.59243984,3.07151899 C10.2447881,4.16473179 10.8932417,5.25436028 11.5455899,6.34757308 C11.6955326,6.60026653 11.7909507,6.62356451 12.0596792,6.47660804 C13.0683849,5.91028797 14.0751432,5.34038359 15.0838488,4.77227137 C15.1305842,4.74538908 15.1753723,4.71850681 15.2298969,4.68804023 C15.0215349,4.49627994 14.889118,4.27942955 14.8735395,4.01239887 C14.8443299,3.51238843 15.2182131,3.0751033 15.7420389,2.9926643 C16.2872852,2.90484885 16.7935853,3.19159319 16.9552119,3.67726641 C16.9668957,3.71490161 16.9844215,3.75432895 17,3.79196415 L17,4.12888876 C16.8286369,4.63427565 16.4761741,4.9281886 15.8705613,4.93177291 C15.8491409,4.98912178 15.8257732,5.04647065 15.8082474,5.10381952 C15.2182131,6.96586559 14.6281787,8.83149594 14.0381443,10.693542 C13.9621993,10.9372747 13.8687285,11 13.6019473,11 L3.41168386,11 C3.12542957,11 3.0378007,10.9390668 2.95990837,10.693542 C2.47892327,9.18275773 2.00378007,7.66659704 1.52279497,6.1558128 C1.39427264,5.74720212 1.26185567,5.33859143 1.13138604,4.92818858 C0.679610554,4.92818858 0.338831627,4.76331059 0.126575047,4.40488017 C0.075945028,4.31706471 0.0428407952,4.21849635 0.00194732012,4.12530443 C0,4.00881454 0,3.89770111 0,3.78658768 L0,3.78658768 L0,3.78658768 Z"></path><path d="M8.50216266,12.0021739 L13.1961308,12.0021739 C13.6146523,12.0021739 13.9487016,12.1904891 13.9947773,12.4436141 C14.0408531,12.6991848 13.7778373,12.9315217 13.3727546,12.9889946 C13.3151599,12.9987772 13.2537255,13 13.1961308,13 L3.80435486,13 C3.44726771,13 3.14585544,12.8642663 3.04218498,12.6588315 C2.93467487,12.4533967 3.0345057,12.2210598 3.32055938,12.1036685 C3.46838579,12.04375 3.66420776,12.0021739 3.83699187,12.0021739 C5.39396863,11.9972826 6.94902556,12.0021739 8.50216266,12.0021739 L8.50216266,12.0021739 L8.50216266,12.0021739 L8.50216266,12.0021739 Z"></path></g></g></g></svg></div>
        <div style="margin-left: 20px;">Expert</div>
      </div>
      <div class="right-cart-body">
        <div class="right-cart-body-div">
          <!-- <div class="right-cart-body-title">
            <div><span style="font-size: 20px">$</span><span style="font-size: 38px">3.99</span> <span style="font-size: 12px">monthly</span></div>
            <div class="right-cart-body-button" @click="subscribeClick" @mouseup="log('subscribe')">Subscribe</div>
          </div> -->
          <span class="right-cart-text"><span class="checkmark">✔</span> Custom Theme</span>
          <span class="right-cart-text"><span class="checkmark">✔</span> More Fashion Backgrounds</span>
          <span class="right-cart-text"><span class="checkmark">✔</span> Unlimited Avatar Pro Features</span>
          <span class="right-cart-text"><span class="checkmark">✔</span> Check Server Region</span>
          <span class="right-cart-text"><span class="checkmark">✔</span> Find Best Connection Server</span>
          <span class="right-cart-text"><span class="checkmark">✔</span> View Server Ping Value</span>
          <span class="right-cart-text"><span class="checkmark">✔</span> Custom Font Color</span>
          <span class="right-cart-text"><span class="checkmark">✔</span> Bulk Unfriend</span>
          <span class="right-cart-text"><span class="checkmark">✔</span> View Friends Status</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {clickLog, sleep} from "@/js/common";
import Cookies from "js-cookie";
import {onMounted, ref} from "vue";
import { serverHost} from "@/js/config";
export default {
  name: "OrderCart",
  setup(){
    let beginMonitor = ref(false)

    const log = (flag) => {
      clickLog(flag)
    }

    const subscribeClick = ()=>{
      let identityId = Cookies.get('identityId');
      if (Cookies.get('logged-on') === 'Y' && identityId){
          window.location.href = window.location.origin + '/' + identityId + '/account#paypal'
      }else {
        window.open(serverHost+'v1/authenticate/loginWithGoogle','Login',"height=500, width=400, top=100, left=300, toolbar=no, menubar=no, scrollbars=no, resizable=no,location=no, status=no")
        beginMonitor.value = true
      }
    }

    const monitor = async ()=>{
      // eslint-disable-next-line no-constant-condition
      while (true){
        let token_id = Cookies.get('rokit-id-token')
        let identityId = Cookies.get('identityId')
        if (token_id && beginMonitor.value && identityId){
          window.location.href = window.location.origin +'/'+ identityId+'/account#paypal'
          break
        }
        await sleep(3000)
      }
    }

    onMounted(()=>{
      monitor()
    })
    return {subscribeClick,log}
  }
}
</script>

<style scoped>
hr{
  margin-bottom: 10%;border: solid 1.5px #1f2427;
}
.left-cart{
  margin-top: 2%;
  height: 430px;
  box-shadow: 0 2px 6px 0 rgb(255 225 174 / 48%);
  border-radius: 27px;
}
.center{
  display: flex;
  justify-content: center;
  align-items: center;
}
.order-cart{
  display: flex;
  justify-content: center;
}
.free-title{
  background-color: #1f2427;
  box-shadow: 0 0 18px 0 rgba(71, 83, 90, 0.51);
  border-top-right-radius: 27px;
  border-top-left-radius: 27px;
  border: solid 2.5px #47535a;
  border-bottom: 0;
  width: 350px;
  height: 80px;
  font-size: 32px;
  font-weight: 700;
  color: #fff;
}
.checkmark{
  color: #04ba76;
  margin-right: 10px;
}
.expert-title{
  background-color: #141516;
  box-shadow: 0 2px 18px 0 rgba(255, 225, 174, 0.48);
  border-top-right-radius: 27px;
  border-top-left-radius: 27px;
  border: solid 2.5px #ffe0b1;
  border-bottom: 0;
  width: 350px;
  height: 80px;
  font-size: 32px;
  font-weight: 700;
  color: #ffe0b1;
}
.right-cart-body{
  border-bottom-left-radius: 27px;
  border-bottom-right-radius: 27px;
  background-color: #333a3e;
  border: solid 2.5px #ffe0b1;
  width: 350px;
  padding-bottom: 10%;
}
.left-cart-body{
  border-bottom-left-radius: 27px;
  border-bottom-right-radius: 27px;
  background-color: #333a3e;
  border: solid 2.5px #47535a;
  width: 350px;
  padding-bottom: 10%;
}
.right-cart-body-div,.left-cart-body-div{
  width: 80%;
  margin: auto;
}
.left-cart-body-title{
  font-size: 23px;
  margin: 10% auto;
}
.right-cart-text, .left-cart-text{
  display: block;
  font-size: 16px;
  margin: 6% auto;
}
.right-cart-body-title{
  margin: 10% auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #ffe0b1;
}
.right-cart-body-button{
  cursor: pointer;
  font-size: 20px;
  font-weight: 700;
  color: #5e3b10;
  display: flex;
  justify-content: center;
  align-items: center;

  width: 130px;
  height: 40px;
  border-radius: 8px;
  box-shadow: 0 6px 13px 0 #3f301d;
  background-image: linear-gradient(to bottom, #efd7b3, #dcb17e);
}
</style>